import React, { useState } from 'react';
import MainImage from '../../images/portfolio/Berserk/video-thumbnail.png';
import PortfolioPage from '../../components/PortfolioPage';
import { StaticImage } from 'gatsby-plugin-image';

const Berserk = () => {
    return <PortfolioPage 
        img={MainImage} 
        url="https://player.vimeo.com/video/1057114933"
        title="Berserk - The Branch & To Små Bulgarere"
        description={<div>
          <p>
            Vikinger: Forferdelige, brutale skapninger som plyndrer og dreper. Nå som de har et hemmelig våpen, blir de bare enda mer blodtørstige. Hva er det disse sopp-etende, villmennene har funnet på nå da?
          </p>
          <br />
          <p>
            (2025)
          </p>
          <br />
          <p>
            ‘Berserk’ er en musikkvideo i samarbeid med musikkduoen To Små Bulgarere. Samarbeidet kom til da vi tenkte de artige ideene til Øystein Dolmen og Jovan Pavlovic passet perfekt med med vår lidenskap for underholdende og levende animasjonsstil. Filmen ble støttet av Midtnorsk Filmsenter, Trondheim kommune og Fond for lyd og bilde, og hadde premiere på kortfilmfestivalen i Grimstad 2025.
          </p>
          <div className="mt-16">
            <p>INFO</p>
            <ul className='list-disc pl-4 mt-2'>
              <li>Lengde 03:46</li>
              <li>Språk: Norsk</li>
              <li>Regi og animasjon: The Branch</li>
              <li>Sang ‘Berserk’ av To Små Bulgarere</li>
              <li>Produsent: Peter A. Clayborough</li>
              <li>Bakgrunner: Magne Skagen</li>
              <li>Compositing: Audun A. E. Løkås</li>
              <li>Med: Øystein Dolmen og Jovan Pavloviv</li>
              <li>Lyddesign og miks: Katarzyna Maria Wieczorek</li>
            </ul>
          </div>
        </div>}
    >
        <div className="flex  justify-center mt-32 lg:px-0 flex-wrap mb-12">
          <StaticImage src="../../images/portfolio/Berserk/1-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/2-artwork.pngg" /> 
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/3-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/4-artwork.png" /> 
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/5-artwork.png" />
        </div>
    </PortfolioPage>

}

export default Berserk;